import React, { useEffect, useRef } from 'react'

import { ModalBody } from './__internal__/modal-body'
import { ModalContent } from './__internal__/modal-content'
import { ModalFullWidthAnchorElementButton } from './__internal__/modal-full-width-anchor-element-button'
import { ModalFullWidthButton } from './__internal__/modal-full-width-button'
import { ModalImage } from './__internal__/modal-image'
import { ModalTitle } from './__internal__/modal-title'
import type { ModalVisibility } from './modal-visibility'

export function Modal({
  children,
  modalVisibility,
  onClose,
}: {
  readonly children: React.ReactNode
  readonly modalVisibility: ModalVisibility
  readonly onClose: () => void
}) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(
    function setModalVisibility() {
      const dialog = dialogRef.current

      if (modalVisibility === 'visible' && dialog?.open === false) {
        dialog?.showModal()
        return
      }

      if (modalVisibility === 'hidden' && dialog?.open === true) {
        dialog?.close()
        return
      }
    },
    [modalVisibility],
  )

  useEffect(
    function setOnCloseHandler() {
      const dialog = dialogRef.current
      dialog?.addEventListener('close', onClose)
      return function cleanup() {
        dialog?.removeEventListener('close', onClose)
      }
    },
    [onClose],
  )

  return (
    <dialog
      className={
        'm-auto rounded-[20px] backdrop:bg-acorns-slate backdrop:opacity-25 shadow-lg'
      }
      ref={dialogRef}
    >
      {children}
    </dialog>
  )
}

Modal.Content = ModalContent
Modal.Image = ModalImage
Modal.Title = ModalTitle
Modal.Body = ModalBody
Modal.FullWidthButton = ModalFullWidthButton
Modal.FullWidthAnchorElementButton = ModalFullWidthAnchorElementButton
